'use strict';

var styled = require('styled-components');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const HeaderStyled = styled__default.default.th `
  padding: ${({ theme }) => `${theme.space.table.m} ${theme.space.table.s} ${theme.space.table.m} ${theme.space.table.xxs}`};
  text-align: left;
  font-size: ${({ theme }) => theme.typography.fontSize.s};
  font-weight: ${({ theme }) => theme.typography.fontWeight.bold};
  line-height: ${({ theme }) => theme.typography.lineHeight.s};
  letter-spacing: ${({ theme }) => theme.typography.letterSpacing.m};
  color: ${({ theme }) => theme.colors.body.textDark};
  position: relative;

  &:first-child {
    padding-left: ${({ theme }) => theme.space.table.s};
  }
`;
const HeaderContainerStyled = styled__default.default.div `
  display: flex;
  align-items: center;
  user-select: none;
  padding-right: ${({ theme }) => theme.space.table.m};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;
const HeaderFilterContainerStyled = styled__default.default(HeaderContainerStyled) `
  cursor: pointer;
`;

exports.HeaderContainerStyled = HeaderContainerStyled;
exports.HeaderFilterContainerStyled = HeaderFilterContainerStyled;
exports.HeaderStyled = HeaderStyled;
//# sourceMappingURL=header.styles.js.map
